import { render } from "./OpportunityForm.vue?vue&type=template&id=280daaee&scoped=true"
import script from "./OpportunityForm.vue?vue&type=script&lang=js"
export * from "./OpportunityForm.vue?vue&type=script&lang=js"

import "./OpportunityForm.vue?vue&type=style&index=0&id=280daaee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280daaee"]])

export default __exports__